import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StatusIndicator from 'Components/StatusIndicator/StatusIndicator';
import { STATUS } from 'utils/enums';
import './PreviewStatus.css';

interface PreviewStatusProps {
  pending: boolean;
  publishDate: string | null;
  profileStatus: STATUS;
  t: ReturnType<typeof useTranslation>['t'];
}

const PreviewStatus = ({ pending, publishDate, profileStatus, t }: PreviewStatusProps) => {
  let mainText: string;
  let dateStr: string | null = null;

  if (pending) {
    mainText = t('profile.preview.status.saving');
  } else {
    switch (profileStatus) {
      case STATUS.DRAFT:
        mainText = t('profile.preview.status.unsaved');
        break;
      case STATUS.NOT_PUBLISHED:
        mainText = t('profile.preview.status.not-published');
        break;
      case STATUS.PUBLISHED:
        mainText = t('profile.preview.status.published');
        if (publishDate) {
          dateStr = new Date(publishDate).toLocaleString(undefined, {
            dateStyle: 'short',
            timeStyle: 'short',
          });
        }
        break;
      default:
        mainText = t('profile.preview.status.not-published');
    }
  }

  return (
    <div className="preview-status">
      <StatusIndicator status={pending ? STATUS.DEFAULT : profileStatus} />
      <Typography variant="body2" component="span" sx={{ color: 'text.primary' }}>
        <span className="preview-status-main">{mainText}</span>
        {dateStr && <span className="preview-status-date"> · {dateStr}</span>}
      </Typography>
    </div>
  );
};

export default PreviewStatus;
